import { useMutation } from '@tanstack/react-query'

import { useUpFetch } from '../../utils'

export const useUploadLoadPreferredRate = ({ loadId }: { loadId: number }) => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async (data: {
      currency: 'EUR' | 'GBP' | 'PLN' | 'USD'
      preferred_rate: number
    }) => {
      return upFetch(`/loads/${loadId}/rates/final-rate`, {
        body: data,
        method: 'PATCH',
      })
    },
  })
}
